/**
 * Created by Greg on 3/30/2016.
 */
import React from 'react';
import {Modal, Button, FormControl, Popover, OverlayTrigger} from 'react-bootstrap';
import { connect } from 'react-redux';
import {net2NetworkXJSON, netJSONreduce} from './../../validation/netValid';

var ExportNetDialog = React.createClass({
    helpPopover(){
        return (<Popover id="exportNetHelpPopover" title="Export Network Help">
            <p>This is the a JSON based representation of the current network suitable
                for saving in a plain text file. This format is compatible with the
             <a target="_blank" href="https://networkx.github.io/">NetworkX</a> Python graph library.</p>
            <p>Examples of working with such JSON networks are given at <a target="_blank"
               href="http://grotto-networking.com/SDNfun.html#NetworkX">Grotto Networking</a>.</p>
        </Popover>)
    },

    render(){
        let netString = JSON.stringify(net2NetworkXJSON(this.props.net), netJSONreduce, 2);
        return(
        <Modal show={this.props.open} onHide={this.props.close} dialogClassName="export-net-modal" >
            <Modal.Header closeButton>
                <Modal.Title>Current Network JSON</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{paddingBottom: 0}}>
                <FormControl componentClass="textarea" readOnly value={netString} rows={10} style={{resize: "none"}}/>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={this.props.close} >Close</Button>
                <OverlayTrigger trigger="click" placement="top" overlay={this.helpPopover()}>
                    <Button bsStyle={'info'}>Help</Button>
                </OverlayTrigger>
            </Modal.Footer>
            </Modal> 
    )}
});

const mapStateToProps = (state) => {
    return {
        open: state.uiState.showNetExportModal,
        net: state.net
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        close: () => {
            dispatch({type: 'CLOSE_NET_EXPORT_DIALOG'});
        },

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExportNetDialog)




// WEBPACK FOOTER //
// ./src/io/ExportNetDialog.js